import React, {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {getActiveRound, getSingleInvestor} from '../../investor-database/core/_requests'
import {InvestorDetails} from './InvestorDetails'
import {InvestorNavBar} from './InvestorNavBar'
import {useAuth} from '../../auth'
import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import {getAllColumnsFromRoundIdIU} from '../core/_requests'
// import {roleValues} from '../../../core/_constants'

export const InvestorPageLayout = () => {
  const [investor, setInvestor] = useState<any>()
  const [activeRound, setActiveRound] = useState<any>()
  const [columns, setColumns] = useState<any>()
  const {investorId, investorUserId} = useParams()
  const {companyId, role} = useAuth()

  const {formatMessage} = useIntl()

  const navigate = useNavigate()

  const getInvestor = async () => {
    try {
      // if (investorId && role && activeRound?.roundId && role !== roleValues.BILLING) {
      if (investorId && role && activeRound?.roundId) {
        const {
          data: {success, data, errors},
        } = await getSingleInvestor(+investorId, activeRound?.roundId)
        if (success) {
          setInvestor(data)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
          navigate('/investor-crm')
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  const getActiveRoundFromApi = async () => {
    try {
      // if (companyId && role && role !== roleValues.BILLING) {
      if (companyId) {
        const {
          data: {success, data: apiActiveRound, errors},
        } = await getActiveRound(companyId)
        if (success) {
          setActiveRound(apiActiveRound)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    // if (companyId && role && role !== roleValues.BILLING) {
    if (companyId) {
      getActiveRoundFromApi()
    }
  }, [companyId, role]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getInvestor()
  }, [investorId, activeRound, role]) // eslint-disable-line react-hooks/exhaustive-deps

  const getAllColumnsFromRoundIdApi = async () => {
    try {
      const {
        data: {success, data: allColumns},
      } = await getAllColumnsFromRoundIdIU(activeRound?.roundId)
      if (success) {
        setColumns(allColumns)
      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    // if (activeRound?.roundId && role && role !== roleValues.BILLING) {
    if (activeRound?.roundId) {
      getAllColumnsFromRoundIdApi()
    }
  }, [activeRound, role]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <InvestorDetails
        getInvestor={getInvestor}
        investorId={investorId}
        investorUserId={investorUserId}
        investor={investor}
        activeRound={activeRound}
        columns={columns}
        setColumns={setColumns}
        getAllColumnsFromRoundIdApi={getAllColumnsFromRoundIdApi}
      />
      <InvestorNavBar
        investor={investor}
        getInvestor={getInvestor}
        activeRound={activeRound}
        investorUserId={investorUserId}
      />
    </>
  )
}
